module.exports = __webpack_public_path__ + "img/WM_vaccinecard.72c2a01b.png";